import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class DriverPaidExpenseReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            isLoading:false,
            getInvoicedReportUrl:'/api/v1/portal/portal-admin/driver-paid-expense-report',
            InvoicedJobsReportData:[],
            downloadReportName:'Driver Paid Expense Report',
            selectedDrivers:[],
            selectedExpenceType:[],
            drivers:[],
            url: "/api/v1/portal/drivers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleDriverSelection = this.handleDriverSelection.bind(this);
        this.handleExpenceTypeSelection = this.handleExpenceTypeSelection.bind(this);
    }
    componentDidMount() {
        this.getAllDrivers();
    }
    getAllDrivers(){
        let options = [];   
        return fetch(this.state.url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
              response.map((driver)=>{
                options.push({
                    label : driver.company.short_name+'-'+driver.first_name+' '+driver.last_name,
                    value : driver.driver.id
                });
            });
            this.setState({
              drivers: options,
              isLoading: false
            });
          });
        });
    }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleDriverSelection(selectedDrivers) {
        this.setState({selectedDrivers});
    }
    handleExpenceTypeSelection(selectedExpenceType) {
        this.setState({selectedExpenceType});
    }
    handleInvoicedJobsReportGeneration(e) {
        this.setState({isLoading: true});
        let url = this.state.getInvoicedReportUrl;
        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify({
            driver_ids: this.state.selectedDrivers,
            start_date:moment(this.state.startDate).format("YYYY-MM-DD"),
            end_date:moment(this.state.endDate).format("YYYY-MM-DD"),
            expense_type: this.state.selectedExpenceType,
          }),
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
            this.setState({
                InvoicedJobsReportData: response,
                isLoading: false
            })
          });
        });
    }
    download(filename, text) {
        filename = filename+" From "+moment(this.state.startDate).format("YYYY-MM-DD")+" To "+moment(this.state.endDate).format("YYYY-MM-DD")+'.csv';
        let reportData = "";
        $('.daily-delivered-report-tbl tr').each(function () {
            $(this).find('td').each(function () {
                reportData = reportData + ($(this).text().replace(',', '')) + ',';
            });
            reportData = reportData + '\n';
        });
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
    render() {
        let invoicedJobs = [];
        const {selectedDrivers, selectedExpenceType} = this.state;
        let downloadableCsvDataInvoiced = "Job Ref, Driver Name, Expense Type, Expense amount Nett (no VAT included), Amount Paid to driver\n";
        if(this.state.InvoicedJobsReportData.length > 0){
            this.state.InvoicedJobsReportData.map((currentJob, index) => {
            let joburl = "/jobs/view/"+currentJob.job_id;
                invoicedJobs.push(
                    <tr key={index}>
                        <td className="job-ref-font16"><a href={joburl}>{currentJob.job_id}</a></td>
                        <td>{_.get(currentJob, 'job.vehicle.registration_number',_.get(currentJob, 'job.vehicle.vin_number'))}</td>
                        <td>{currentJob.driver.user.first_name} {currentJob.driver.user.last_name}</td>
                        <td>{currentJob.description}</td> 
                        <td>&pound;{_.round(currentJob.nett_amount, 2)}</td> 
                        <td>&pound;{_.round(currentJob.driver_pay, 2)}</td> 
                    </tr>
            );

            downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                                            currentJob.job_id+','+
                                            _.get(currentJob, 'job.vehicle.registration_number',_.get(currentJob, 'job.vehicle.vin_number'))+','+
                                            currentJob.driver.user.first_name +' '+ currentJob.driver.user.last_name+','+
                                            currentJob.description+','+
                                            _.round(currentJob.nett_amount, 2)+','+
                                            _.round(currentJob.driver_pay, 2)+','+
                                            ''+"\n";
            });
        }else{
            invoicedJobs.push(
                <tr key='no-records'><td colSpan="26" className='text-center'>No Records</td></tr>
            );
        }
        const expenceTypeOptions = [
            { label: "Fuel Oil Adblue", value: 4001 },
            { label: "Vehicle Movements", value: 4000 },
            { label: "Toll Road", value: 4002 },
            { label: "Waitingtime", value: 4003 },
            { label: "Storage", value: 4004 },
            { label: "Breakdown", value: 4005 },
            { label: "Travel", value: 4006 },
            { label: "Car Wash", value: 4007 },
            { label: "Parts", value: 4008 },
            { label: "Transport Services", value: 4009 },
            { label: "Hotel", value: 7402 },
            { label: "Electric Charge Cost", value: 4014 },
            { label: "Electric Charging Time", value: 4015 },
            { label: "Truck Fuel", value: 4021 },
            { label: "Truck Travel", value: 4022 },
            { label: "Air", value: 4023 },
            { label: "Food", value: 4024 },
            { label: "Water", value: 4025 },
            { label: "Coolant", value: 4026 },
            { label: "Parking", value: 4027 },
        ];
        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Driver Paid Expense Report</h2>
                    <br/>
                </div>
                
                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Driver</h5></label><br/>
                            <div>
                                <StatefulMultiSelect
                                    options={this.state.drivers}
                                    selected={selectedDrivers}
                                    onSelectedChanged={this.handleDriverSelection}
                                        overrideStrings={{
                                            selectSomeItems: "Select Drivers...",
                                            allItemsAreSelected: "All Drivers are Selected",
                                            selectAll: "Select All",
                                            search: "Search Driver",
                                        }}
                                    />
                            </div>
                    </div>
                    <div className="col-md-2 col-sm-12">
                        <label><h5>Select Expense Type</h5></label><br/>
                        <div> 
                        <StatefulMultiSelect
                            options={expenceTypeOptions}
                            selected={selectedExpenceType}
                            onSelectedChanged={this.handleExpenceTypeSelection}
                            overrideStrings={{
                                selectSomeItems: "Select expense type...",
                                allItemsAreSelected: "All expense types are Selected",
                                selectAll: "Select All",
                                search: "Search expense type",
                            }} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate Driver Paid Expense Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                    onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                  }}>
                                <i className="fa fa-download"></i> Download Driver Paid Expense Report
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3"><label className="alert alert-primary"><b>{this.state.InvoicedJobsReportData.length} Expense found..</b></label></div>             
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl no-footer">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        <th>Job Ref</th>
                                        <th>REG/VIN</th>
                                        <th>Driver Name</th>
                                        <th>Expense Type</th>
                                        <th>Expense amount Nett (no VAT included)</th>
                                        <th>Amount Paid to driver</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="26"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    invoicedJobs
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-driver_paid_expense_report')) {
    ReactDOM.render(
        <DriverPaidExpenseReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-driver_paid_expense_report')
    );
}